/**
 * The billing plans Starter and freemium have a maximum number of members per company
 */
export const STARTER_PLAN_SEAT_LIMIT = 7;
export const FREEMIUM_PLAN_SEAT_LIMIT = 4;
